// ============================================
// Auth Slice - DEV mode authentication only
// Real auth is now handled by TanStack Query in hooks/auth
// ============================================

import { StateCreator } from 'zustand';
import type { User, UserRole } from '../../types/auth';

// Session duration: 3 hours in milliseconds
const SESSION_DURATION = 3 * 60 * 60 * 1000;

export interface AuthState {
  // Auth state (DEV mode only)
  user: User | null;
  sessionExpiry: number | null;
  
  // Auth actions
  isSessionValid: () => boolean;
  login: (role: Exclude<UserRole, 'pending'>) => boolean;
  logout: () => void;
  setUser: (user: User) => void;
}

export const createAuthSlice: StateCreator<AuthState, [], [], AuthState> = (set, get) => ({
  // Initial state
  user: null,
  sessionExpiry: null,
  
  // Check if session is valid
  isSessionValid: () => {
    const { sessionExpiry } = get();
    if (!sessionExpiry) return false;
    return Date.now() < sessionExpiry;
  },
  
  // Login with role (DEV mode only)
  login: (role: Exclude<UserRole, 'pending'>) => {
    const roleNames = {
      analyst: 'Аналітик',
      developer: 'Розробник',
      viewer: 'Глядач'
    };
    
    const user: User = {
      id: `dev-${role}-${Date.now()}`,
      email: `${role}@dev.local`,
      displayName: roleNames[role],
      role: role,
      emailVerified: true,
      createdAt: new Date().toISOString(),
      settings: { theme: 'dark' }
    };
    
    const sessionExpiry = Date.now() + SESSION_DURATION;
    set({ user, sessionExpiry });
    console.log('[Login] DEV User set:', user, 'Session expires at:', new Date(sessionExpiry).toISOString());
    return true;
  },
  
  // Set user from Firebase Auth
  setUser: (authenticatedUser: User) => {
    const sessionExpiry = Date.now() + SESSION_DURATION;
    set({ user: authenticatedUser, sessionExpiry });
    console.log('[Login] User set from Firebase Auth:', authenticatedUser, 'Session expires at:', new Date(sessionExpiry).toISOString());
  },
  
  // Logout
  logout: () => {
    set({ 
      user: null, 
      sessionExpiry: null
    });
  }
});
